// auth.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
// import { defaultConfig } from '../API-Urls/urls';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private apiUrl = environment.url;
  private apiUrl2 = environment.url2;
  // private token = (localStorage.getItem('token'));
  // private tokenFormatted = `Bearer ${this.token?.replace(/"/g, '')}`;

  // private headers = new HttpHeaders({
  //   'Authorization': this.tokenFormatted,
  //   'Accept': '*/*',
  // });

  constructor(private http: HttpClient) { }

  login(email: string, password: string): Observable<any> {
    const body = { email, password };
    return this.http.post<any>(this.apiUrl + 'api/content-programming/login', body);
  }

  logout(accessToken: any): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.post<any>(this.apiUrl + 'api/content-programming/logout', accessToken, { headers: headers});
  }

  chnagePassword(Obj: any): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.post<any>(this.apiUrl + 'api/content-programming/change-password', Obj, { headers: headers });
  }

  getAllTags(): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.get<any>(`${this.apiUrl}tag/getAll`, { headers: headers });
  }

  getAllMusics(filter:any,text:any): Observable<any> {
    let nextext = (text == 'PARTY_TUNES' || text == 'ROMANTIC_TUNES') ? 'callertunes' :'songs';
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    if(filter){
     return this.http.get<any>(`${this.apiUrl}api/global-playlist/${nextext}/${filter.id}`, { headers: headers });
    }else{
      return this.http.get<any>(`${this.apiUrl}api/content-programming/all/${nextext}`, { headers: headers });
    }
  }

  getAllDeployments(): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.get<any>(`${this.apiUrl}service/getAll`, { headers: headers });
  }

  getMusicById(muiscId: any): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.get<any>(`${this.apiUrl}release/getById/${muiscId}`, { headers: headers });
  }

  getAllArtists(name: any): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.get<any>(
      `${this.apiUrl}api/content-programming/container/${name.toUpperCase()}/`,
      { headers: headers }
    );
  }

  getAllFilteredMuiscList(filterData: any): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.post<any>(`${this.apiUrl}filteration/filterData`, filterData, { headers: headers });
  }

  onChangeMusicStatus(filterData: any): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.put<any>(`${this.apiUrl}release/updateApproval`, filterData, { headers: headers });
  }

  onDeployMusicListing(filterData: any): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.post<any>(`${this.apiUrl}distribution/getReleaseIds`, filterData, { headers: headers });
  }

  UpadteTagsStatus(tagsObj: any): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.put<any>(`${this.apiUrl}release/updateTags`, tagsObj, { headers: headers });
  }

  HideSongs(Id: any): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.post<any>(`${this.apiUrl}api/content-programming/hide/song/${Id}`, {}, { headers: headers });
  }

  getAllCountry(
    name: 'TOP_GENRES' | 'UPCOMING_ARTIST' | 'POPULAR_PARTY_HITS' | 'VALENTINES_LOVE_SONGS' | 'GLOBAL_MIX'
  ): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    const endpointMap: { [key: string]: string } = {
      TOP_GENRES: 'api/content-programming/all/genres',
      GLOBAL_MIX: 'api/global-playlist',
      UPCOMING_ARTIST: 'api/content-programming/all/artists',
      POPULAR_PARTY_HITS: 'api/content-programming/all/songs',
      VALENTINES_LOVE_SONGS: 'api/content-programming/all/songs',
    };

    const endpoint = endpointMap[name];
    if (!endpoint) {
      throw new Error(`Invalid name parameter: ${name}`);
    }

    return this.http.get<any>(`${this.apiUrl}${endpoint}`, { headers: headers });
  }

    AddContent(
    name: 'TOP_GENRES' | 'UPCOMING_ARTIST' | 'POPULAR_PARTY_HITS' | 'VALENTINES_LOVE_SONGS' | 'GLOBAL_MIX',
    id: any
  ): Observable<any> {
    let token = localStorage.getItem('token');
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });

    if (!name) throw new Error(`Invalid name parameter: ${name}`);

    if (name === 'GLOBAL_MIX') {
      return this.http.get<any>(`${this.apiUrl}api/global-playlist`, { headers });
    } else {
      return this.http.get<any>(`${this.apiUrl}api/content-programming/containers/data/${id}`, { headers });
    }
  }

  getAllUsers(): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.get<any>(`${this.apiUrl}user/getAll`, { headers: headers });
  }

  getAllpublishers(): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.get<any>(`${this.apiUrl}publisher/getAll`, { headers: headers });
  }

  getAllLanguages(): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.get<any>(`${this.apiUrl}language/getAll`, { headers: headers });
  }

  getAllRoles(id: any): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.get<any>(`${this.apiUrl}api/content-programming/carousel/content/${id}/`, { headers: headers });
  }

  getViewAll(id: any,text:any): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    if(text == 'GLOBAL_MIX'){
      return this.http.get<any>(`${this.apiUrl}api/global-playlist`, { headers: headers });
    }else{
      return this.http.get<any>(`${this.apiUrl}api/content-programming/containers/data/${id}`, { headers: headers });
    }
  }

  getAllGeneres(): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.get<any>(`${this.apiUrl}category/getAll`, { headers: headers });
  }

  addTag(tagData: any): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.post<any>(`${this.apiUrl}tag/add`, tagData, { headers: headers });
  }

  updateTag(tagData: any): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.put<any>(`${this.apiUrl}tag/update`, tagData, { headers: headers });
  }

  updateSequence(tagData: any): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.put<any>(`${this.apiUrl}api/content-programming/update/carousel/sequence`, tagData, { headers: headers });
  }

  updateContainerSequence(tagData: any): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.put<any>(`${this.apiUrl}api/content-programming/update/containers/sequence`, tagData, { headers: headers });
  }

  addDeployment(deploymentData: any): Observable<any> { let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.post<any>(`${this.apiUrl}api/content-programming/container/add/content`, deploymentData, { headers: headers });
  }

  addArtist(artistData: any): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.post<any>(`${this.apiUrl}artist/add`, artistData, { headers: headers });
  }

  addGenre(categoryData: any): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.post<any>(`${this.apiUrl}category/add`, categoryData, { headers: headers });
  }

  addUser(userData: any): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.post<any>(`${this.apiUrl}user/add`, userData, { headers: headers });
  }

  addPublisher(userData: any): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.post<any>(`${this.apiUrl}publisher/add`, userData, { headers: headers });
  }

  addMusic(musicData: any): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.post<any>(`${this.apiUrl}release/add`, musicData, { headers: headers });
  }

  updateMusic(musicId: any, musicData: any): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.put<any>(`${this.apiUrl}release/update/${musicId}`, musicData, { headers: headers });
  }

  updateDeployment(deploymentData: any): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.put<any>(`${this.apiUrl}service/update`, deploymentData, { headers: headers });
  }

  updateArtist(publisherData: any): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.put<any>(`${this.apiUrl}artist/update`, publisherData, { headers: headers });
  }

  updatePublsiher(publisherData: any, id: any): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.put<any>(`${this.apiUrl}api/content-programming/container/enable/${id}/${publisherData}`, {}, { headers: headers });
  }

  updateGenres(id: any, categoryData: any): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.put<any>(`${this.apiUrl}api/content-programming/update/container/${id}`, categoryData, { headers: headers });
  }

  updateUser(userData: any): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.put<any>(`${this.apiUrl}user/update`, userData, { headers: headers });
  }

  updateRole(roleData: any): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.put<any>(`${this.apiUrl}role/update`, roleData, { headers: headers });
  }

  deleteTag(tagId: any, body: any): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.request<any>('DELETE', `${this.apiUrl}api/content-programming/container/content/${tagId}`, {
      body: body,
      headers: headers,
    });
  }
  deleteDeployments(deploymentId: any, itemId: any): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.request<any>('DELETE', `${this.apiUrl}api/content-programming/carousel/content/${deploymentId}/${itemId}`, {
      headers: headers,
    });
  }
  deleteArtist(artistId: any): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.request<any>('DELETE', `${this.apiUrl}artist/delete`, {
      body: artistId,
      headers: headers,
    });
  }
  deleteGenres(genreId: any): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.request<any>('DELETE', `${this.apiUrl}category/delete`, {
      body: genreId,
      headers: headers,
    });
  }
  deleteUser(userId: any): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.request<any>('DELETE', `${this.apiUrl}user/delete`, {
      body: userId,
      headers: headers,
    });
  }
  deletePublisher(publisherId: any): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.request<any>('DELETE', `${this.apiUrl}publisher/delete`, {
      body: publisherId,
      headers: headers,
    });
  }
  deleteMusic(muiscId: string): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.delete<any>(`${this.apiUrl}release/delete/${muiscId}`, { headers: headers });
  }

  deletePlaylist(deleteId: string): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.delete<any>(`${this.apiUrl}api/delete/global-playlist/${deleteId}`, { headers: headers });
  }

   deleteSong(data: any): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.post<any>(`${this.apiUrl}api/global-playlist/remove/song`,data,{ headers: headers });
  }

  CreatePlayList(formData:any){
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.post<any>(`${this.apiUrl}api/create/global-playlist`, formData, { headers: headers });
  }

   CreateUpdatePlayList(updateId:any,formData:any){
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.post<any>(`${this.apiUrl}api/update/global-playlist/${updateId}`, formData, { headers: headers });
  }

  AddPlayList(formData:any){
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.post<any>(`${this.apiUrl}api/global-playlist/add/song`, formData, { headers: headers });
  }

  // Notification Manaement 

  getAllNotifications(page: number = 0, size: number = 10): Observable<any> {
    
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({'Authorization': tokenFormatted,'Accept': '*/*'});
    return this.http.get(`${this.apiUrl2}api/notifications/?page=${page}&size=${size}`, { headers: headers })
  }

  getNotifications(paramsObj: any) {
    let params = new HttpParams();
    Object.keys(paramsObj).forEach(key => {
      if (paramsObj[key]) {
        params = params.set(key, paramsObj[key]);
      }
    });
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({'Authorization': tokenFormatted,'Accept': '*/*'});
    return this.http.get(`${this.apiUrl2}api/notifications/`, { params, headers });
  }

  getTagData(): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.get(`${this.apiUrl2}api/notifications/masters`, { headers: headers })
  }

  pauseNotification(id: any): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.patch(`${this.apiUrl2}api/notifications/${id}/pause`, {}, { headers: headers })
  }

  resumeNotification(id: any): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.patch(`${this.apiUrl2}api/notifications/${id}/resume`, {}, { headers: headers })
  }

  deleteNotification(id: any): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.delete(`${this.apiUrl2}api/notifications/${id}`, { headers: headers })
  }

  downloadSample(): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.get(`${this.apiUrl2}api/notifications/sample-excel`, { responseType: 'blob', headers: headers })
  }

  getNotificationById(id: any): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.get(`${this.apiUrl2}api/notifications/${id}`, { headers: headers })
  }

  scheduleNotification(data: any): Observable<any> {
    
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.post(`${this.apiUrl2}api/notifications/notification`, data , { headers: headers })
  }

  updateScheduleNotification(data: any): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.put(`${this.apiUrl2}api/notifications/notification`, data, { headers: headers })
  }

  getAllSystemEvents(): Observable<any> {
    
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.get(`${this.apiUrl2}api/notifications/system-events`, { headers: headers })
  }

  getSystemEventById(id: any):Observable<any>{
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.patch(`${this.apiUrl2}api/notifications/system-events/${id}`,id,{headers:headers})
  }

  updateSystemEvents(data:any,id:any):Observable<any>{
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.patch(`${this.apiUrl2}api/notifications/system-events/${id}/description`,data,{headers:headers})
  }

  pauseSystemEvent(id: any): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.patch(`${this.apiUrl2}api/notifications/system-events/${id}/pause`, {}, { headers: headers })
  }

  resumeSystemEvent(id: any): Observable<any> {
    let token = (localStorage.getItem('token'));
    let tokenFormatted = `Bearer ${token?.replace(/"/g, '')}`;
    let headers = new HttpHeaders({
      'Authorization': tokenFormatted,
      'Accept': '*/*',
    });
    return this.http.patch(`${this.apiUrl2}api/notifications/system-events/${id}/resume`, {}, { headers: headers })
  }

  // Notification Manaement Api
}
